import { combine, withCallbacks, withContext } from 'react-hooks-combine'
import { ServicesContext } from 'services/context'
import { toaster } from 'utils/toast-wrapper'
import { main } from 'routes/route.map'
import { StoreContext } from 'store/context'

import MakeInWinAddComponent from './component'

export const MakeInWinAdd = combine({
  hooks: [
    withContext('appStore', StoreContext),
    withContext(
      'eventService',
      ServicesContext,
      ({ eventService }) => eventService
    ),

    withContext(
      'memberService',
      ServicesContext,
      ({ memberService }) => memberService
    ),

    withContext(
      'followerService',
      ServicesContext,
      ({ followerService }) => followerService
    ),

    withCallbacks(
      {
        getEventInfoById:
          ({ eventService }) =>
            async (eventId) => {
              const content = await eventService.get(eventId)
              return content
            },
        onSubmit:
          (
            { memberService, followerService, appStore },
            { history, onClose }
          ) =>
            async (inWinFormDTO) => {
              await memberService.binaryInWin(inWinFormDTO)
              toaster.info('InWin has been successfully created')
              // update user balanse
              const entity = appStore.auth.loggedEntity
              await entity.wallet.requestBalance()

              // update count inwins
              await appStore.inwins.load()

              if (onClose) {
                onClose()
              } else {
                history.push(main.index())
              }
            },
      },
      []
    ),
  ],
  transformProps: ({
    match,
    getEventInfoById,
    getTriggers,
    getBeneficiaries,
    getSponsors,
    onSubmit,
    appStore,
    test,
  }) => {
    return {
      eventId: Number(match.params.eventId),
      getEventInfoById,
      getBeneficiaries,
      getTriggers,
      getSponsors,
      test,
      onSubmit,
      wallet: appStore.auth.loggedEntity.wallet,
    }
  },
})(MakeInWinAddComponent)
